//
// Helper methods for managing the Navbar & Config files.
//

/**
 * Helper function to convert a navbar config list to one that only
 * contains those navbar items the current user has permissions
 * to view.
 *
 * @param {object[]} menuItems A list of navbar items
 * @param {object} permissions A Hateoas _links object
 * @param {object[]} roles The current user's roles
 * @returns A navbar config with only permitted locations
 *
 * @see /src/app/shared/config.js For menuItems shape & options
 */
export const navbarPermissionsHelper = (menuItems, permissions, roles = []) => {
  const isAdmin = roles?.some((r) => r.role === "SYSTEM_ADMIN");
  const permittedNavbar = menuItems
    .map((item) => {
      // Parent item? Has children?
      if (item.menuItem?.length > 0) {
        // New parent with permitted items only
        let menu = {
          name: item.name,
          menuItem: [],
        };

        // Check each child
        for (const subItem of item.menuItem) {
          if (permissions?.[subItem?.permName]) {
            // Permission exists, add to new parent
            menu.menuItem.push(subItem);
          }
        }

        // No permitted children
        if (menu.menuItem.length === 0) return null;

        // Return permitted menu & children items
        return menu;
      } else {
        // Admin-only route: gate strictly on the SYSTEM_ADMIN role
        if (item.route && item.adminOnly) {
          return isAdmin ? item : null;
        }
        // No children items, check for navigable route
        if (item.route && permissions?.[item?.permName]) {
          return item;
        }
        return null;
      }
    })
    // Remove empty entries
    .filter((permitted) => permitted);

  return permittedNavbar;
};
